import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["tagName", "size", "name", "logo", "image", "icon", "invert", "color", "bgColor", "className", "disabled"];
import { cnBem, forwardRefWithTag } from '@carnica/utils';
import React, { useMemo } from 'react';
import { getAvatarMode } from "./utils";
import { AvatarContent } from "./AvatarContent";
import styles from "./styles.pcss";
export var cnAvatar = cnBem('avatar', styles);
export var Avatar = forwardRefWithTag(function (props, ref) {
  var _props$tagName = props.tagName,
    tagName = _props$tagName === void 0 ? 'div' : _props$tagName,
    _props$size = props.size,
    size = _props$size === void 0 ? 'm' : _props$size,
    name = props.name,
    logo = props.logo,
    image = props.image,
    icon = props.icon,
    invert = props.invert,
    color = props.color,
    _props$bgColor = props.bgColor,
    bgColor = _props$bgColor === void 0 ? 'default' : _props$bgColor,
    className = props.className,
    disabled = props.disabled,
    otherProps = _objectWithoutProperties(props, _excluded);
  var Tag = tagName;
  var type = useMemo(function () {
    return getAvatarMode(props);
  }, [name, disabled, logo, image, icon, size]);
  return /*#__PURE__*/React.createElement(Tag, _extends({
    className: cnAvatar({
      size: size,
      color: color,
      disabled: disabled,
      type: type,
      bgColor: invert ? 'invert' : bgColor
    }, [className]),
    disabled: disabled,
    ref: ref
  }, otherProps), /*#__PURE__*/React.createElement(AvatarContent, {
    bgColor: bgColor,
    disabled: disabled,
    icon: icon,
    image: image,
    logo: logo,
    name: name,
    size: size
  }));
});